
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UserGroup } from 'bandon-shared';
import { IonAvatar, IonItem, IonLabel, IonNote, IonText } from "@ionic/angular/standalone";

@Component({
  selector: 'app-group-list-item',
  templateUrl: './group-list-item.component.html',
  styleUrls: ['./group-list-item.component.scss'],
  standalone: true,
  imports: [
    IonItem,
    TranslateModule,
    IonAvatar,
    IonLabel,
    IonText,
    IonNote
]
})
export class GroupListItemComponent  implements OnInit {
  @Input() group: UserGroup;
  @Input() detail = false;
  @Input() showGroupDescription = true;
  @Input() showUserLimit = false;
  @Input() lines: 'full' | 'inset' | 'none' | undefined = undefined;

  constructor() { }

  ngOnInit() {}

}
